import { Icon } from "shared/styles";
import { borderRadius, colors, space } from "shared/styles/constants";
import styled from "styled-components";

export const StyledDraggableOption = styled.div`
  padding: ${space.m} ${space.l};
  background-color: ${colors.blackLight};
  border-radius: ${borderRadius.xs};

  > * {
    flex: 0 0 auto;
  }
`;

export const StyledDraggableOptionIcon = styled(Icon)`
  margin-top: ${space.xxs};
`;
